var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { isSsr } from './general';
/**
 *  GENERIC ANALYTICS FUNCTIONS
 */
/**
 * Function for updating page data in the global variable _T
 * @param digitalData - the digital data object we want to push to page data array
 */
export var setAnalytics = function (digitalData) {
    var _a, _b, _c;
    var exchange = (_c = (_b = (_a = window.digitalData) === null || _a === void 0 ? void 0 : _a.user) === null || _b === void 0 ? void 0 : _b.profile) === null || _c === void 0 ? void 0 : _c.exchange;
    var _ddo = digitalData.init();
    if ((_ddo === null || _ddo === void 0 ? void 0 : _ddo.user) && exchange) {
        _ddo.user = __assign(__assign({}, _ddo.user), { profile: __assign(__assign({}, _ddo.user.profile), { exchange: exchange }) });
    }
    if (!isSsr) {
        window._T = window._T || {};
        if (typeof window._T.pageData === 'undefined') {
            window._T.pageData = [];
        }
        window._T.pageData.push(_ddo);
    }
};
/**
 * Function for updating an event array in the global variable digitalData
 * @param analyticsEvent - an event object we want to push to event array
 */
export var pushEventInfo = function (analyticsEvent) {
    if (analyticsEvent && !isSsr && window.digitalData) {
        try {
            window.digitalData.event = window.digitalData.event || [];
            window.digitalData.event.push(analyticsEvent);
            setAnalytics(window.digitalData);
        }
        catch (err) {
            // eslint-disable-next-line no-console
            console.error('DDO : Error in pushing the event info!!!');
        }
    }
};
/**
 * Function for setting page details in the global variable digitalData
 * @param page - an page details object we want to set in the digitalData
 */
export function setPageDetails(page, extraFields) {
    var _a, _b;
    if (extraFields === void 0) { extraFields = {}; }
    var postOrderReturn = extraFields.postOrderReturn, user = extraFields.user;
    if (!isSsr && window.digitalData) {
        try {
            window.digitalData.page = page;
            if (postOrderReturn) {
                window.digitalData.postOrderReturn = postOrderReturn;
            }
            if (user) {
                window.digitalData.user = __assign(__assign({}, window.digitalData.user), { profile: __assign(__assign({}, (_a = window.digitalData.user) === null || _a === void 0 ? void 0 : _a.profile), { exchange: (_b = user === null || user === void 0 ? void 0 : user.profile) === null || _b === void 0 ? void 0 : _b.exchange }) });
            }
            setAnalytics(window.digitalData);
        }
        catch (err) {
            // eslint-disable-next-line no-console
            console.error('DDO : Error in setting the page object and initializing it!!!');
        }
    }
}
export var defaultPageInfo = {
    category: {
        primaryCategory: 'account',
        subCategory1: 'account>purchase history',
        subCategory2: 'account>purchase history>order details>return items',
    },
    pageInfo: {
        pageName: 'account>purchase history>order details>return items',
        pageType: 'maml: return items',
    },
};
export var setPageInfoWithEventCategories = function (primaryCategory, subCategory1, subCategory2, pageName, pageType) {
    var page = {
        category: {
            primaryCategory: primaryCategory,
            subCategory1: subCategory1,
            subCategory2: subCategory2,
        },
        pageInfo: {
            pageName: pageName,
            pageType: pageType,
        },
    };
    setPageDetails(page);
};
export var setPageInfoWithEvent = function (primaryCategory, subCategory1, subCategory2, pageName, pageType, pageLoadEvent) {
    var page = {
        category: {
            primaryCategory: primaryCategory,
            subCategory1: subCategory1,
            subCategory2: subCategory2,
        },
        pageInfo: {
            pageName: pageName,
            pageType: pageType,
            pageLoadEvent: pageLoadEvent,
        },
    };
    setPageDetails(page);
};
export var sendReturnItemData = function (postOrderReturn) {
    var _a;
    if (!isSsr && !window.digitalData.postOrderReturn) {
        window.digitalData.postOrderReturn = { item: [] };
    }
    (_a = postOrderReturn === null || postOrderReturn === void 0 ? void 0 : postOrderReturn.item) === null || _a === void 0 ? void 0 : _a.forEach(function (returnItem) {
        if (!isSsr)
            window.digitalData.postOrderReturn.item.push(returnItem);
    });
    window.digitalData.postOrderReturn.transactionID =
        postOrderReturn.transactionID;
    setAnalytics(window.digitalData);
};
